import React from "react";
import { Button, Dialog, DialogContent } from "@mui/material";
import { useAppState } from "../../../../Redux/ReduxHooks";
import { Dispatch } from "../../../Dispatch";
import { getContentUrl, ContentURL } from "../../../Utils/ContentURL";
import "./Notifications.scss";

/** Component to display error messages in a dialog. */
export const ErrorMessage: React.FC = () => {

    const errorMessage = useAppState(i => i.PhoneToCnp.ErrorMessage);

    if (!errorMessage) return null;

    const handleClose = () => {
        Dispatch.PhoneToCnp.HideErrorMessage();
    };

    return (
        <Dialog
            open={!!errorMessage}
            onClose={handleClose}
        >
            <DialogContent sx={{padding: "0"} }>
                <div className="error-icon-background"><img src={getContentUrl(ContentURL.images.PhoneToCnp.AlertTriangleInErrorMessage)} alt="Error" /></div>
                <div className="error-title">{errorMessage.Title}</div>
                <div className="error-message">{errorMessage.Message}</div>
                <Button className="error-button" variant="outlined" onClick={handleClose}>{errorMessage.ButtonText}</Button>
            </DialogContent>
        </Dialog>
    )
}